import { useUrlIssueIdCheck } from 'liga-detail';
import { defineComponent, ref, computed } from 'vue-demi';
import store from '@/store';
import { useRootInstance } from '@/utils/useRootInstance';
import router from '@/router';
export default defineComponent({
  name: 'DefaultLayoutSwitcher',
  setup(_, { slots }) {
    const showDefaultLayout = ref(true);
    const instance = useRootInstance();

    const menuLoadEnd = ref(false);
    const isShareMode = computed(() => !!store?.state.user.shareInfo?.projectId || router.currentRoute?.meta?.share);
    function loadMenu(){
      const routeInfo = router.currentRoute;
      if (routeInfo?.meta?.share || !store.getters['user/isLogin']) {
        return;
      }

      store.dispatch('app/updateMenu').then(() => {
        menuLoadEnd.value = true;
      });
    }

    instance.eventBus.$on('global:issueClose', () => {
      showDefaultLayout.value = true;
    });

    instance.eventBus.$on('global:showDefaultLayout', () => {
      showDefaultLayout.value = true;
    });

    const { projectId, issueId } = useUrlIssueIdCheck();

    if (projectId && issueId) {
      showDefaultLayout.value = false;
    }
    loadMenu();
    return () => slots.default?.({ show: showDefaultLayout.value && (menuLoadEnd.value || isShareMode.value) });
  }
});
